/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the WarehouseCreditBalanceDTO interface.
 */
export function instanceOfWarehouseCreditBalanceDTO(value) {
    return true;
}
export function WarehouseCreditBalanceDTOFromJSON(json) {
    return WarehouseCreditBalanceDTOFromJSONTyped(json, false);
}
export function WarehouseCreditBalanceDTOFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'available': json['available'] == null ? undefined : json['available'],
        'availableBalance': json['availableBalance'] == null ? undefined : json['availableBalance'],
        'awaitingPaymentTotal': json['awaitingPaymentTotal'] == null ? undefined : json['awaitingPaymentTotal'],
        'remainingBalance': json['remainingBalance'] == null ? undefined : json['remainingBalance'],
        'currency': json['currency'] == null ? undefined : json['currency'],
        'asOf': json['asOf'] == null ? undefined : (new Date(json['asOf'])),
    };
}
export function WarehouseCreditBalanceDTOToJSON(json) {
    return WarehouseCreditBalanceDTOToJSONTyped(json, false);
}
export function WarehouseCreditBalanceDTOToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'available': value['available'],
        'availableBalance': value['availableBalance'],
        'awaitingPaymentTotal': value['awaitingPaymentTotal'],
        'remainingBalance': value['remainingBalance'],
        'currency': value['currency'],
        'asOf': value['asOf'] == null ? undefined : ((value['asOf']).toISOString()),
    };
}
